// Keep in sync with the API enum (apps/api/src/enums/prospect.enum.ts). UNSUBSCRIBED is the
// persisted sentiment set by the unsubscribe flow; it MUST be listed here or z.nativeEnum in the
// people schema rejects it and the blacklist/unsubscribe UI signals never resolve (PREC-3728).
export enum ProspectInterest {
	INTERESTED = "INTERESTED",
	BAD_TIMING = "BAD_TIMING",
	WRONG_PERSON = "WRONG_PERSON",
	NOT_INTERESTED = "NOT_INTERESTED",
	NEUTRAL = "NEUTRAL",
	OUT_OF_OFFICE = "OUT_OF_OFFICE",
	MEANINGLESS = "MEANINGLESS",
	UNSUBSCRIBED = "UNSUBSCRIBED",
}

/**
 * Sentiments a user can assign manually in the reply UIs. The system-derived statuses
 * (OUT_OF_OFFICE / MEANINGLESS collapse to NEUTRAL before persisting; UNSUBSCRIBED comes from the
 * unsubscribe flow) are intentionally excluded so they never appear as pickable options.
 */
export const MANUAL_PROSPECT_SENTIMENTS: ProspectInterest[] = [
	ProspectInterest.INTERESTED,
	ProspectInterest.BAD_TIMING,
	ProspectInterest.WRONG_PERSON,
	ProspectInterest.NOT_INTERESTED,
	ProspectInterest.NEUTRAL,
];
